export * from './BuildingOfficeIcon';
export * from './BuildingOfficeIcon16Light';
export * from './BuildingOfficeIcon16Regular';
export * from './BuildingOfficeIcon16Solid';
export * from './BuildingOfficeIcon20Light';
export * from './BuildingOfficeIcon20Regular';
export * from './BuildingOfficeIcon20Solid';
export * from './BuildingOfficeIcon24Regular';
export * from './BuildingOfficeIcon24Solid';
export * from './BuildingOfficeIcon32Regular';
export * from './BuildingOfficeIcon64Regular';
